import { logError, TAGS } from '@iwLogger/IwDataDogLogger';
import {
    fetchGetFundingRequirements,
    GetFundingRequirementsResponse
} from '@iwoca/lapi-client/edge_de';
import { useQuery } from '@tanstack/react-query';

import { useFundingRequirementsParams } from './useFundingRequirementsParams';

type TFundingRequirementsData = GetFundingRequirementsResponse['data'];

type TUseGetFundingRequirementsOptions = {
    // How often to refetch, in ms, given the latest requirements. False stops polling.
    refetchInterval?: (data?: TFundingRequirementsData) => number | false;
};

export function useGetFundingRequirements({
    refetchInterval
}: TUseGetFundingRequirementsOptions = {}): TFundingRequirementsData {
    const { offerId, drawdownAmount } = useFundingRequirementsParams();

    const { data } = useQuery({
        queryKey: ['fetchGetFundingRequirements', offerId, drawdownAmount],
        queryFn: () =>
            fetchGetFundingRequirements({
                offerId,
                query: { cash_amount: drawdownAmount }
            }),
        select: (response) => response.data,
        suspense: true,
        refetchInterval
    });

    if (!data) {
        const message = `useGetFundingRequirements: funding requirements not found: ${offerId}`;
        logError(message, { tags: TAGS.DE_LENDING });
        throw new Error(message);
    }

    return data;
}
